var map = {
	"./01_Conegliano.png": 1315,
	"./02_Unesco.png": 7031,
	"./03_Confartigianato.png": 1004,
	"./04_Confcommercio.png": 7080,
	"./05_Rotaract.png": 6178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9203;